import { useTranslation } from 'react-i18next';
import { ConfigEditor } from '@/components/config-editor';
import { useOrgNavigate } from '@/hooks/use-app-navigate';
import { buildInstanceCdnUrl } from '@/lib/utils/cdn';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';

export default withRequiredPermission(InstanceConfigEditorPage, PERMISSIONS.STORES_MANAGE);

function InstanceConfigEditorPage() {
  const { t } = useTranslation('storefront');
  const { instanceId } = useParams();
  const navigate = useNavigate();
  const { orgRoutes } = useOrgNavigate();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');
  const initialPagePath = searchParams.get('pagePath') || undefined;

  const handleClose = () => {
    if (returnUrl) {
      // Decode in case the returnUrl was double-encoded
      const decoded = returnUrl.startsWith('%') ? decodeURIComponent(returnUrl) : returnUrl;
      navigate(decoded);
    } else {
      navigate(orgRoutes.STORES());
    }
  };

  if (!instanceId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-gray-600">{t('editor.instanceIdRequired')}</p>
      </div>
    );
  }

  const previewUrl = buildInstanceCdnUrl(instanceId);

  return <ConfigEditor instanceId={instanceId} previewUrl={previewUrl} onClose={handleClose} initialPagePath={initialPagePath} />;
}
